import { render } from "./Form2.vue?vue&type=template&id=5b3d0026"
import script from "./Form2.vue?vue&type=script&lang=js"
export * from "./Form2.vue?vue&type=script&lang=js"

import "./Form2.vue?vue&type=style&index=0&id=5b3d0026&lang=scss"
script.render = render

export default script